import SEO from "@/components/common/SEO";
import PageHeader from "@/components/shared/PageHeader";
import { Reveal, Icon } from "@/components/common/motion";
import { FAQSection, ContactCTA } from "@/components/shared/blocks";
import { ProcessSection } from "@/components/home/Sections";
import { services } from "@/data/site";
import { Check } from "lucide-react";

export default function Services() {
  return (
    <>
      <SEO title="Services" description="End-to-end technology services: software development, web & mobile apps, cloud, DevOps, AI, data engineering, cyber security and managed IT." path="/services" />
      <PageHeader
        overline="Services"
        title="Technology services, end to end"
        subtitle="One accountable partner across the full lifecycle — strategy, design, engineering, security and support."
      />

      <section className="py-20 sm:py-28">
        <div className="mx-auto max-w-7xl space-y-24 px-5 sm:px-8">
          {services.map((s, i) => (
            <div key={s.slug} id={s.slug} className="scroll-mt-28" data-testid={`service-detail-${s.slug}`}>
              <div className={`grid items-center gap-12 lg:grid-cols-2 ${i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""}`}>
                <Reveal>
                  <div className="mb-5 flex items-center gap-3">
                    <span className="grid h-12 w-12 place-items-center rounded-xl bg-primary text-primary-foreground shadow-lg"><Icon name={s.icon} className="h-6 w-6" /></span>
                    <span className="text-xs font-bold uppercase tracking-[0.22em] text-primary">Service {String(i + 1).padStart(2, "0")}</span>
                  </div>
                  <h2 className="font-display text-3xl font-medium tracking-tight md:text-4xl">{s.title}</h2>
                  <p className="mt-3 text-lg font-medium text-foreground/80">{s.tagline}</p>
                  <p className="mt-4 text-muted-foreground leading-relaxed">{s.description}</p>
                  <ul className="mt-7 grid gap-3 sm:grid-cols-2">
                    {s.features.map((f) => (
                      <li key={f} className="flex items-center gap-3 text-sm">
                        <span className="grid h-5 w-5 shrink-0 place-items-center rounded-full bg-success/15 text-success"><Check className="h-3 w-3" /></span>
                        {f}
                      </li>
                    ))}
                  </ul>
                </Reveal>
                <Reveal delay={0.12}>
                  <div className="group relative overflow-hidden rounded-3xl border border-border shadow-xl">
                    <img src={s.image} alt={s.title} loading="lazy" className="h-[24rem] w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                    <div className="absolute inset-0 bg-gradient-to-t from-secondary/40 to-transparent" />
                  </div>
                </Reveal>
              </div>
            </div>
          ))}
        </div>
      </section>

      <ProcessSection />
      <FAQSection limit={8} />
      <ContactCTA />
    </>
  );
}
